import { defineMessages } from '@jutro/locale';

export default defineMessages({
    makeChanges: {
        id: 'ml.endorsement.common.pages.policySummary.Make Changes',
        defaultMessage: 'Make Changes'
    },
    quotingPolicyChange: {
        id: 'ml.endorsement.common.pages.policySummary.Quoting policy change',
        defaultMessage: 'Quoting policy change'
    },
});